import {RESOLVE_THEME_FROM_SETTINGS} from '.';
import defaultTheme from '../constants/DefaultTheme';
import {createMuiTheme} from '@material-ui/core';

const resolveThemeFromSettings = (checkoutSettings, {dispatch}) => {
  const {primaryColor, secondaryColor, textColor, secondaryTextColor, alternateTextColor, disabledColor, backgroundColor, borderColor, font}  = checkoutSettings.theme;

  let theme = {};
  Object.assign(theme, defaultTheme);

  if (primaryColor) {
    theme.palette.primary.light = primaryColor;
    theme.palette.primary.main = primaryColor;
    theme.palette.primary.dark = primaryColor;
  }

  if (secondaryColor) {
    theme.palette.secondary.light = secondaryColor;
    theme.palette.secondary.main = secondaryColor;
    theme.palette.secondary.dark = secondaryColor;
  }

  if (textColor) {
    theme.palette.text.primary = textColor;
  }

  if (secondaryTextColor) {
    theme.palette.text.secondary = secondaryTextColor;
  }

  if (alternateTextColor) {
    theme.palette.text.hint = alternateTextColor;
  }

  if (backgroundColor) {
    theme.palette.background.paper = backgroundColor;
    theme.palette.background.default = backgroundColor;
  }

  if (disabledColor) {
    theme.palette.action.disabled = disabledColor;
  }

  if (borderColor) {
    // theme.palette.borderColor = borderColor;
  }

  if (font && font.fontFamily) {
    const fontFamily = '"' + font.fontFamily + '","Roboto", "Helvetica", "Arial", "sans-serif"';
    theme.typography.fontFamily = fontFamily;
    theme.typography.h1.fontFamily = fontFamily;
    theme.typography.h2.fontFamily = fontFamily;
    theme.typography.h3.fontFamily = fontFamily;
    theme.typography.h4.fontFamily = fontFamily;
    theme.typography.h5.fontFamily = fontFamily;
    theme.typography.h6.fontFamily = fontFamily;
    theme.typography.subtitle1.fontFamily = fontFamily;
    theme.typography.subtitle2.fontFamily = fontFamily;
    theme.typography.body1.fontFamily = fontFamily;
    theme.typography.body2.fontFamily = fontFamily;
    theme.typography.button.fontFamily = fontFamily;
    theme.typography.caption.fontFamily = fontFamily;
    theme.typography.overline.fontFamily = fontFamily;

    // Inject stylesheet if a font url is present
    if (font.fontUrl) {
      let link = window.document.createElement('link');
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = font.fontUrl;
      window.document.head.appendChild(link);
      window.document.body.style = 'font-family: ' + theme.fontFamily;
    }
  }

  dispatch({
    type: RESOLVE_THEME_FROM_SETTINGS,
    theme: createMuiTheme(theme)
  });
};

export default resolveThemeFromSettings;
